import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import { camelize, snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { fullApiUrl } from '@rover/utilities/apiUrl';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

const buildPersonSummaryUrl = (personUrl: string): string => `${personUrl}summary/`;

export const PERSON_SUMMARY_URL = fullApiUrl('frontend/user-person-summary/');
export const get = async (personUrl: string | null | undefined): Promise<any> => {
  const ai = getAxiosInstance();

  try {
    const { data } = await ai.get(
      personUrl ? buildPersonSummaryUrl(personUrl) : PERSON_SUMMARY_URL
    );
    return camelize(data, true);
  } catch (e: any) {
    const { response } = e;

    if (response?.status === 404) {
      return {};
    }
    if (
      response?.status === 401 &&
      response?.data?.detail === 'Authentication credentials were not provided.'
    ) {
      // On unauthenticated home page, we should expect a 401 from this endpoint
      return {};
    }

    return DefaultAPIErrorHandler(e, "There was an error fetching person's summary.");
  }
};
export const save = async (personData: any, personUrl?: string): Promise<any> => {
  const ai = getAxiosInstance();

  try {
    const { data } = await ai.patch(personUrl || personData.url, snakeify(personData, true));
    return camelize(data, true);
  } catch (e: any) {
    const { response } = e;

    if (response && response.status === 404) {
      return [];
    }

    return DefaultAPIErrorHandler(e, "There was an error saving person's summary.");
  }
};
